import * as yup from 'yup';
import ValidationUtil from "../Utils/ValidationUtil";

class OperatorValidation {

    static validate(form) {
        try {

            let validate = yup.object().shape({
                name: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                email: yup
                    .string()
                    .email(ValidationUtil.MSG_FIELD_EMAIL)
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                company: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
            });

            validate.validateSync(form, {abortEarly: false})

            return true;

        } catch (e) {
            let erros = [];
            e.inner.forEach(function (value, index) {
                erros[value.path] = value.message;
            });

            return erros;
        }
    }

}

export default OperatorValidation